import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import moment from 'moment'
import router from './router'
import 'utils/permission'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/fonts/iconfont.css'
import store from './store'
import promise from 'es6-promise';
import './assets/css/common.scss'
import '@babel/polyfill';

promise.polyfill();
import {
  Pagination,
  Dialog,
  Autocomplete,
  Input,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Select,
  Cascader,
  Option,
  Button,
  Table,
  TableColumn,
  DatePicker,
  Tooltip,
  Form,
  Upload,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Icon,
  Row,
  Col,
  Badge,
  Card,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Loading,
  MessageBox,
  Message,
  Alert,
  Image,
} from 'element-ui';

Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Input);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Select);
Vue.use(Cascader);
Vue.use(Option);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(Tooltip);
Vue.use(Form);
Vue.use(Upload);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Alert);
Vue.use(Image);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
function MyMessage(option) {
  Message.closeAll()
  Message(option)
}
MyMessage.success = function (option) {
  Message.closeAll()
  Message.success(option)
}
MyMessage.warning = function (option) {
  Message.closeAll()
  Message.warning(option)
}
MyMessage.error = function (option) {
  Message.closeAll()
  Message.error(option)
}
MyMessage.info = function (option) {
  Message.closeAll()
  Message.info(option)
}
Vue.prototype.$message = MyMessage;

import { LayoutPlugin, NavbarPlugin, LinkPlugin } from 'bootstrap-vue';
Vue.use(LinkPlugin);
Vue.use(LayoutPlugin);
Vue.use(NavbarPlugin);

Vue.config.productionTip = false;

Vue.prototype.$moment = moment;

Vue.prototype.$moneyFormat = function (number, decimals, dec_point, thousands_sep) {
  /*
  * 参数说明：
  * number：要格式化的数字
  * decimals：保留几位小数
  * dec_point：小数点符号
  * thousands_sep：千分位符号
  * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.ceil(n * k) / k;
    };

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
};

// 表单验证
import VeeValidate, { Validator } from 'vee-validate';

Validator.extend('phone', {
  getMessage: () => '手机号格式错误',
  validate: value => {
    return /^1[345789]\d{9}$/.test(value)
  }
})
Validator.extend('age', {
  getMessage: () => '年龄最大为120',
  validate: value => {
    return /^\d$|^[1-9]\d*$/.test(value) && value <= 120
  }
})
Validator.extend('files', {
  getMessage: () => '文件格式错误或大小超过10Mb',
  validate: (value, [accept]) => {
    if (value.size >= 10485760) {
      return false;
    } else if (accept && accept.indexOf(value.type) < 0) {
      return false;
    } else {
      return true;
    }
  }
});
const config = {
  fieldsBagName: 'fieldBags',
};
Vue.use(VeeValidate, config);
// 二维码插件
import VueQriously from 'vue-qriously'

Vue.use(VueQriously)

// 上传
import md5 from 'crypto-js/md5';
import { upload } from "api/common";

Vue.prototype.$uploadFile = function (e) {
  return new Promise(function (resolve, reject) {
    var fileMd5 = md5(e.file, 'utf-8');
    var partFile = e.file;
    e.onProgress({ percent: 0 });
    var data = { fileMd5, partFile };
    if (e.data) {
      if (e.data.type) {
        data.type = e.data.type
      }
      if (e.data.innerItem) {
        data.code = e.data.innerItem.code
      }
    }
    upload(data).then(function (res) {
      resolve({ fileNo: res.data, fileName: e.file.name });
      e.onProgress({ percent: 1 });
      e.onSuccess(res);
    }).catch(err => {
      reject(err)
      e.onError(err);
    })
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  data: {
    eventBus: new Vue({
      methods: {

      }
    })
  }
});



// WEBPACK FOOTER //
// ./src/main.js